import Dashboard from "@/common/components/layout/Dashboard";
import Toast from "@/common/components/ui/toast";
import { ToastProvider } from "@/common/components/ui/toast/toast.provider";
import MaintenanceDashboard from "./MaintenanceDashboard";

function DashboardMaintenance() {
	return (
		<ToastProvider>
			<Dashboard>
				<MaintenanceDashboard />
			</Dashboard>
			<Toast />
		</ToastProvider>
	)
}

export default DashboardMaintenance